<a href="" [routerLink]="['/tags/' + state?.tag?.name]" class="tag-wrapper">
  <span class="tag-label">
    {{ state?.tag?.name }}
  </span>
</a>
